import { BinaryWriter } from './BinaryWriter';
import { BinaryReader } from './BinaryReader';
import { MessageTag } from './messageTags';

/**
 * Helpers for the game's framing convention: every message is `[ushort MessageTag (LE)][payload]`.
 * Server side this is `packet.Put((ushort)messageTag)` then the payload (Game.Services/BaseClass/Network.cs);
 * client side the tag is read first (Client/Assets/Network.cs).
 */

/** Starts a new outbound message with the tag already written. Chain payload puts, then toUint8Array(). */
export function beginMessage(tag: MessageTag): BinaryWriter {
  const writer = new BinaryWriter();
  writer.putUShort(tag);
  return writer;
}

/** Reads the leading tag and returns a reader positioned at the payload. */
export function readMessage(data: Uint8Array): { tag: MessageTag; reader: BinaryReader } {
  const reader = new BinaryReader(data);
  const tag = reader.getUShort() as MessageTag;
  return { tag, reader };
}
